var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.teamsiteConfig)?_c('mq-call-to-action',{attrs:{"action":{ text: _vm.signupBtnText, url: _vm.routes.signUpUrl },"color":_vm.teamsiteConfig.color}},[_c('h1',{staticClass:"cta"},[_vm._v("\n      "+_vm._s(_vm.$t('teamsite.call_to_action.title'))+"\n    ")])]):_vm._e(),_vm._v(" "),_vm._t("post-cta-section")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408dd517","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GiantCta.vue
// module id = null
// module chunks = 